"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertyTypeForm = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ontology_functions_context_1 = require("../../shared/ontology-functions-context");
const type_form_1 = require("../shared/type-form");
const expected_value_selector_1 = require("./property-type-form/expected-value-selector");
const PropertyTypeForm = ({ baseUrl, ...props }) => {
    const { validateTitle: remoteValidation } = (0, ontology_functions_context_1.useOntologyFunctions)();
    const validateTitle = async (title) => remoteValidation({
        kind: "property-type",
        title,
    });
    return ((0, jsx_runtime_1.jsx)(type_form_1.TypeForm, { validateTitle: validateTitle, ...props, children: (0, jsx_runtime_1.jsx)(expected_value_selector_1.ExpectedValueSelector, { propertyTypeBaseUrl: baseUrl }) }));
};
exports.PropertyTypeForm = PropertyTypeForm;
